import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  :root {
    --primary: #0A1929;       /* Deep navy blue background */
    --secondary: #132F4C;     /* Slightly lighter blue */
    --accent: #1E88E5;        /* Vibrant blue accent */
    --background: #0A1929;    /* Deep navy blue background */
    --dark-bg: #132F4C;       /* Slightly lighter blue */
    --text: #F0F7FF;          /* Ice blue text */
    --text-light: #F0F7FF;    /* Ice blue text */
    --text-secondary: #B2BAC2; /* Muted blue-gray text */
    --font-main: 'Poppins', sans-serif;
    --font-secondary: 'Roboto', sans-serif;
    --transition: all 0.3s ease;
    --shadow: 0 10px 30px rgba(0, 10, 30, 0.7); /* Deep blue shadow */
    --radius: 8px;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: var(--font-main);
    background-color: var(--background);
    color: var(--text);
    line-height: 1.7;
    overflow-x: hidden;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  ul {
    list-style: none;
  }

  button, input, textarea {
    font-family: var(--font-main);
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 700;
    line-height: 1.2;
  }

  h1 {
    font-size: clamp(2.5rem, 5vw, 4rem);
  }

  h2 {
    font-size: clamp(2rem, 4vw, 3rem);
  }

  h3 {
    font-size: clamp(1.5rem, 3vw, 2.5rem);
  }

  .container {
    width: 90%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 1rem;
  }

  .section {
    padding: 5rem 0;
  }

  @media screen and (max-width: 768px) {
    .section {
      padding: 3rem 0;
    }
  }
`;

export default GlobalStyles;
